<template>
  <div class="gmb-attribute-item" v-if="attribute">
    <GmbAttributeChip
      :name="attribute.displayName"
      :value="attribute.value"
      :delete-mode="deleteMode"
      @input="selectValue"
    ></GmbAttributeChip>
  </div>
</template>

<script>
import GmbAttributeItem from "@/components/FacilityDetails/GmbAttributes/GmbAttributeItem.vue";

export default {
  name: "GmbAttributeItemBool",
  extends: GmbAttributeItem
};
</script>
